<template>
    <div>
        <template v-if="crud_company === true">
            <div class="page-top mb-1 mb-3 row">
                <div class="col">
                    <h1> Company View </h1>
                </div>
                <div class="col btn-holder text-right">
                    <router-link :to="{path: '/allCompanies'}" class="mr-2 btn btn-primary">Previous</router-link>
                </div>
            </div>
            <div class="">
                <div class="modal fade onboarding-modal" id="popupModal" tabindex="-1" role="dialog" aria-labelledby="popupModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body" style="align-self:center">
                                <img :src="popup_image_path" alt="" style="width:400px;height:400px;">
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-cancel" data-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-primary" @click="downloadImg(popup_image_path)">Download</button>
                            </div>
                        </div>
                    </div>    
                </div>
                <div class="modal fade" id="getDocumnentVerificationReason" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body login-mobilizer text-left p-4">
                                    <div class="moblizer-account-detail">
                                        <div class="alert alert-danger pl-1" v-if="documentVerificationErrorMessage!==''">{{documentVerificationErrorMessage}}</div>
                                        <label class="label block-label"> Reason to {{documentVerificationReasonText}}: </label>
                                        <div class="form-group mb-2">
                                            <textarea v-model="documentVerificationReason" class="form-control"  ></textarea>
                                        </div>
                                        <div class="row normal-ib-space mt-3">
                                            <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                            <div class="col"> <button class="btn btn-primary active" id="verify_document" @click="updateVerificationStatus()"> Submit </button> </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
                <div class="modal fade" id="getCompanyVerificationReason" tabindex="-1" role="dialog" aria-labelledby="loginMoblizerLabel" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-body login-mobilizer text-left p-4">
                                <div class="moblizer-account-detail">
                                    <div class="alert alert-danger pl-1" v-if="companyVerificationErrorMessage!==''">{{companyVerificationErrorMessage}}</div>
                                    <template v-if="companyVerification == 0">
                                        <label class="label block-label"> Reason to reject company: </label>
                                    </template>
                                    <template v-if="companyVerification == 2">
                                        <label class="label block-label"> <b>Request Approver for company approval:</b> </label>
                                        <label class="inline-label"><b>Action:</b></label>
                                        <label class="radio-holder">
                                            <small>Approve</small>
                                            <input type="radio" value="1" checked  v-model="approverAction">
                                            <span class="checkmark"></span>
                                        </label>
                                        <label class="radio-holder">
                                            <small>Reject</small>
                                            <input type="radio" value="0"  v-model="approverAction">
                                            <span class="checkmark"></span>
                                        </label>
                                    </template>
                                    <template v-if="companyVerification == 3">
                                        <label class="label block-label"> Reason to approve company (Rejected Company): </label>
                                    </template>
                                    <div class="form-group mb-2">
                                        <label><b>Remarks:</b></label>
                                        <textarea v-model="companyVerificationReason" class="form-control"  ></textarea>
                                    </div>
                                    <div class="row normal-ib-space mt-3">
                                        <div class="col"> <button class="btn btn-primary" data-dismiss="modal" aria-label="Close"> Cancel </button> </div>
                                        <div class="col"> <button  class="btn btn-primary active" id="reject_company" @click="updateCompanyStatus()"> Submit </button> </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="onboarding-form-outer">
                    <div class="onboarding-main detail-view">
                        <div class="">
                            <div class="table-holder">
                                <div class="row align-items-center mb-lg-5 mb-4 p-2">
                                    <div class="col-8">
                                        <h3 class="section-title">Company Risk Rating</h3>
                                    </div>
                                    <div class="col text-right">
                                        <button class="mr-2 btn btn-primary" @click="saveRiskRating()">Save Current Risk Rating</button>
                                    </div>
                                </div>
                                <table class="table">
                                    <tr>
                                        <td>City</td>
                                        <td>{{risk_rating.individualRatings.city_rating}}</td>
                                        <td>{{$riskRatingStatus(risk_rating.individualRatings.city_rating)}}</td>
                                        <td>{{risk_rating.city}}</td>
                                    </tr>
                                    <tr>
                                        <td>Industry</td>
                                        <td>{{risk_rating.individualRatings.industry_rating}}</td>
                                        <td>{{$riskRatingStatus(risk_rating.individualRatings.industry_rating)}}</td>
                                        <td>{{risk_rating.industry}}</td>
                                    </tr>
                                    <tr>
                                        <td>Throughput</td>
                                        <td>{{risk_rating.individualRatings.throughputRating}}</td>
                                        <td>{{$riskRatingStatus(risk_rating.individualRatings.throughputRating)}}</td>
                                        <td>{{risk_rating.throughput}}</td>
                                    </tr>
                                    <tr>
                                        <td>Account Purpose</td>
                                        <td>{{risk_rating.individualRatings.purposeRating}}</td>
                                        <td>{{$riskRatingStatus(risk_rating.individualRatings.purposeRating)}}</td>
                                        <td>{{risk_rating.purpose}}</td>
                                    </tr>
                                    <tr>
                                        <td>Account Type</td>
                                        <td>{{risk_rating.individualRatings.accountTypeRating}}</td>
                                        <td>{{$riskRatingStatus(risk_rating.individualRatings.accountTypeRating)}}</td>
                                        <td>{{risk_rating.type}}</td>
                                    </tr>
                                    <tr>
                                        <td class="bg-warning">Total Risk Rating</td>
                                        <td class="bg-warning">{{risk_rating.accumulatedRating}}</td>
                                        <td class="bg-warning">{{$accumulatedRiskRatingStatus(risk_rating.accumulatedRating)}}</td>
                                        <td class="bg-warning">-</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="table-holder">
                                <form action="" class="hide">
                                    <div class="form-group">
                                        <input type="text" placeholder="Company Name" value="Rozee.pk" class="form-control">
                                        <label for="" class="absolute-label">Company Name</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Size of Company" value="500" class="form-control">
                                        <label for="" class="absolute-label">Size of Company</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Type of Company" value="Fintech" class="form-control">
                                        <label for="" class="absolute-label">Type of Company</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Monthly Throughput" value="etc" class="form-control">
                                        <label for="" class="absolute-label">Monthly Throughput</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Monthly Sales" value="Rs. 400,000.000" class="form-control">
                                        <label for="" class="absolute-label">Monthly Sales</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Year of Incorporation" value="2013" class="form-control">
                                        <label for="" class="absolute-label">Year of Incorporation</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Company Address" value="2-A Zafar Ali Road, Gulberg v, Lahore" class="form-control">
                                        <label for="" class="absolute-label">Address</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="City" value="Lahore" class="form-control">
                                        <label for="" class="absolute-label">Lahore</label>
                                    </div>
                                    <div class="btn-holder text-md-right">
                                        <a href="#" class="btn-cancel">Cancel</a><input type="submit" value="Save" class="btn-save">
                                    </div>
                                </form>
                                <div class="row align-items-center mb-lg-5 mb-4 p-2">
                                    <div class="col-8">
                                        <h3 class="section-title">Company Details</h3>
                                    </div>
                                    <div class="col text-right">
                                        <router-link :to="{path: '/editOnboardedCompany/'+companyId}" class="edit-btn"><i class="fas fa-pencil-alt"></i> Edit</router-link>
                                    </div>
                                </div>
                                <table class="table">
                                    <tr>
                                        <td>Company Name</td>
                                        <td>{{ company_details.company_name }}</td>
                                    </tr>
                                    <tr>
                                        <td>Size of Company</td>
                                        <td>{{ company_details.company_company_size }}</td>
                                    </tr>
                                    <tr>
                                        <td>Type of Company</td>
                                        <td>{{ company_details.company_industry_type }}</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly Througput</td>
                                        <td>{{ company_details.company_monthly_throughput }}</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly Sales</td>
                                        <td>{{ company_details.company_monthly_sales }}</td>
                                    </tr>
                                    <tr>
                                        <td>Year of Incorporation</td>
                                        <td>{{ company_details.company_year_of_incorporation }}</td>
                                    </tr>
                                    <tr>
                                        <td>Company Address</td>
                                        <td>{{ company_details.company_address_1 }}</td>
                                    </tr>
                                    <tr>
                                        <td>City</td>
                                        <td>{{ company_details.company_city_id }}</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="table-holder">
                                <form action="" class="hide">
                                    <div class="form-group">
                                        <input type="text" placeholder="Approver Name" value="Qasif Shahid" class="form-control">
                                        <label for="" class="absolute-label">Approver Name</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Approver Mobile Number" value="O300-1234567" class="form-control">
                                        <label for="" class="absolute-label">Approver Mobile Number</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Approver CNIC Number" value="3260909523088" class="form-control">
                                        <label for="" class="absolute-label">Approver CNIC Number</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Gender" value="Male" class="form-control">
                                        <label for="" class="absolute-label">Gender</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Approver Email" value="contact@mail.com" class="form-control">
                                        <label for="" class="absolute-label">Approver Email</label>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">CNIC Front Approver</span>
                                        <input type="file" class="file-up-btn" id="approvercnic" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="approvercnic" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">CNIC Back Approver</span>
                                        <input type="file" class="file-up-btn" id="approvercnic2" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="approvercnic2" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="btn-holder text-md-right">
                                        <a href="#" class="btn-cancel">Cancel</a><input type="submit" value="Save" class="btn-save">
                                    </div>
                                </form>
                                <div> <!-- //Approver Details -->
                                    <div class="row align-items-center mb-lg-5 mb-4 p-2">
                                        <div class="col-8">
                                            <h3 class="section-title">Approver Details</h3>
                                        </div>
                                        <div class="col text-right">
                                            <router-link :to="{path: '/editOnboardedCompany/'+companyId}" class="edit-btn"><i class="fas fa-pencil-alt"></i> Edit</router-link>
                                        </div>
                                    </div>
                                    <table class="table">
                                        <tr>
                                            <td>Approver Name</td>
                                            <td>{{ company_details.user_name }}</td>
                                        </tr>
                                        <tr>
                                            <td>Approver Mobile Number</td>
                                            <td>{{ company_details.user_mobile_no }}</td>
                                        </tr>
                                        <tr>
                                            <td>Approver CNIC Number</td>
                                            <td>{{ company_details.user_cnic }}</td>
                                        </tr>
                                        <tr>
                                            <td>Gender</td>
                                            <td>{{ company_details.user_gender }}</td>
                                        </tr>
                                        <tr>
                                            <td>Approver Email</td>
                                            <td>{{ company_details.user_email }}</td>
                                        </tr>
                                        <tr>
                                            <td>Approver CNIC Front Side</td>
                                            <td>
                                                <div v-if="company_details.cnic_front_path !== null" class="img-outer" @click="view_image(cnic_bucket_path+company_details.cnic_front_path)">
                                                    <img :src="cnic_bucket_path+company_details.cnic_front_path" alt="CNIC Front side not uploaded" style="width:100px;height:69px;">
                                                    <!-- <img :src="$global.aws_base_url+'/images/img-placeholder.png'" alt=""> -->
                                                </div>
                                                <div v-else class="text-danger">
                                                    CNIC Front side not uploaded
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Approver CNIC Back Side</td>
                                            <td>
                                                <div v-if="company_details.cnic_back_path !== null" class="img-outer" @click="view_image(cnic_bucket_path+company_details.cnic_back_path)">
                                                    <img :src="cnic_bucket_path+company_details.cnic_back_path" alt="CNIC Back side not uploaded" style="width:100px;height:69px;">
                                                    <!-- <img :src="$global.aws_base_url+'/images/img-placeholder.png'" alt=""> -->
                                                </div>
                                                <div v-else class="text-danger">
                                                    CNIC Back side not uploaded
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                            <div class="table-holder">
                                <form action="" class="hide">
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">Form 20/A</span>
                                        <input type="file" class="file-up-btn" id="form20" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="form20" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">NTN</span>
                                        <input type="file" class="file-up-btn" id="NTN" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="NTN" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">Partner Ship Deed</span>
                                        <input type="file" class="file-up-btn" id="partnership" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="partnership" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">Certificate of incorporation</span>
                                        <input type="file" class="file-up-btn" id="certificate" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="certificate" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="btn-holder text-md-right">
                                        <a href="#" class="btn-cancel">Cancel</a><input type="submit" value="Save" class="btn-save">
                                    </div>
                                </form>
                                <div class="row align-items-center mb-lg-5 mb-4 p-2">
                                    <div class="col-8">
                                        <h3 class="section-title">Required Documents</h3>
                                    </div>
                                    <div class="col text-right">
                                        <router-link :to="{path: '/editOnboardedCompanyDocuments/'+companyId}" class="edit-btn"><i class="fas fa-pencil-alt"></i> Edit</router-link>
                                    </div>
                                </div>
                                <table class="table table-approve">
                                    <tr v-for="(uploaded_document,index) in uploaded_documents" :id="uploaded_document.id" v-bind:key="uploaded_document.id">
                                        <td class="col-10">{{uploaded_document.doc_title}} <small v-if="uploaded_document.is_required == 'YES'" style="color:#ec6c49">( Required )</small></td>
                                        <td class="col-1">
                                            <div v-if="typeof(uploaded_document.path) != 'undefined' && uploaded_document.path !== null" class="doc-outer btn btn-primary">
                                                <a :href="documents_bucket_path+uploaded_document.path" target="_blank">Download</a>
                                            </div>
                                        </td>
                                        <td class="col-1">
                                            <div v-if="uploaded_document.status == 'APPROVED'" class="btn-holder text-success">
                                                APPROVED
                                            </div>
                                            <div v-else class="btn-holder">
                                                <div v-if="approve_onboarded_company_document">
                                                    <button type="button" class="approve-btn btn btn-success btn-sm" @click="documentVerify(uploaded_document.comp_doc_id, 'approve')">Approve</button>
                                                    <button type="button" class="reject-btn btn btn-danger btn-sm" @click="documentVerify(uploaded_document.comp_doc_id, 'reject')">Reject</button>
                                                </div>
                                                <div v-else class="text-danger">
                                                    Pending
                                                </div>
    <!-- <a class="approve-btn" href="#">Approve</a><a class="reject-btn" href="#">Reject</a> -->
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="(required_document,index) in required_documents" :id="required_document.id" v-bind:key="required_document.id">
                                        <td>{{required_document.doc_title}} <small v-if="required_document.is_required == 'YES'" style="color:#ec6c49">( Required )</small></td>
                                        <td></td>
                                        <td>
                                            <div class="btn-holder text-danger">
                                                Not Uploaded
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="table-holder">
                                <form action="" class="hide">
                                    <div class="form-group">
                                        <input type="text" placeholder="Name" value="Qasif Shahid" class="form-control">
                                        <label for="" class="absolute-label">Name</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="CNIC Number" value="3260909523088" class="form-control">
                                        <label for="" class="absolute-label">CNIC Number</label>
                                    </div>
                                    <div class="form-group">
                                        <input type="text" placeholder="Contact Number" value="O300-1234567" class="form-control">
                                        <label for="" class="absolute-label">Contact Number</label>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">CNIC Front Approver</span>
                                        <input type="file" class="file-up-btn" id="approvercniclast" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="approvercniclast" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="form-group upload-outer">
                                        <span class="upload-title">CNIC Back Approver</span>
                                        <input type="file" class="file-up-btn" id="approvercnic2last" accept=".jpeg,.jpg,.png,.gif,.bmp,.pdf,.doc,.docx" name="image" required> 
                                        <label for="approvercnic2last" class="btn-upload-file">Upload</label>
                                        <span class="uploaded-file"></span>
                                    </div>
                                    <div class="btn-holder text-md-right">
                                        <a href="#" class="btn-cancel">Cancel</a><input type="submit" value="Save" class="btn-save">
                                    </div>
                                </form>
                                <div><!-- User Details -->
                                    <div class="" v-if="company_users.length > 1">
                                        <div class="col-8">
                                            <h3 class="section-title">User Details</h3>
                                        </div>
                                    </div>
                                    <div class="container-fluid"> <!-- users -->
                                        <div v-for="(company_user,index) in company_users" :id="'accordian'+company_user.user_id" class="accordian" v-bind:key="company_user.user_id">
                                            <div v-if="index > 0">
                                                <div class="card">
                                                    <div class="card-header" id="headingOne">
                                                        <h5 class="mb-0">
                                                            <button class="btn btn-link collapsed" data-toggle="collapse" :data-target="'#firstperson'+company_user.user_id" aria-expanded="true" :aria-controls="'firstperson'+company_user.user_id">
                                                            {{ index }}. {{ company_user.user_name }} <span> {{company_user.role}}  </span> <i class="fas fa-chevron-up"></i> <i class="fas fa-chevron-down"></i>
                                                            </button>
                                                        </h5>
                                                    </div>

                                                    <div :id="'firstperson'+company_user.user_id" class="collapse" aria-labelledby="headingOne" :data-parent="'#accordian'+company_user.user_id">
                                                        <div> <!-- //Approver Details -->
                                                            <div class="row align-items-center">
                                                                <div class="col text-right">
                                                                    <!-- <a href="#" class="edit-btn"><i class="fas fa-pencil-alt"></i> Edit</a> -->
                                                                </div>
                                                            </div>
                                                            <table class="table">
                                                                <tr>
                                                                    <td>Approver Name</td>
                                                                    <td>{{ company_user.user_name }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Approver Mobile Number</td>
                                                                    <td>{{ company_user.user_mobile_no }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Approver CNIC Number</td>
                                                                    <td>{{ company_user.user_cnic }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Gender</td>
                                                                    <td>{{ company_user.user_gender }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Approver Email</td>
                                                                    <td>{{ company_user.user_email }}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Approver CNIC Front Side</td>
                                                                    <td>
                                                                        <div v-if="company_user.cnic_front_path !== null" class="img-outer" @click="view_image(cnic_bucket_path+company_user.cnic_front_path)">
                                                                            <img :src="cnic_bucket_path+company_user.cnic_front_path" alt="CNIC Front side not uploaded" style="width:100px;height:69px;">
                                                                            <!-- <img :src="$global.aws_base_url+'/images/img-placeholder.png'" alt=""> -->
                                                                        </div>
                                                                        <div v-else class="text-danger">
                                                                            CNIC Front side not uploaded
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Approver CNIC Back Side</td>
                                                                    <td>
                                                                        <div v-if="company_user.cnic_back_path !== null" class="img-outer" @click="view_image(cnic_bucket_path+company_user.cnic_back_path)">
                                                                            <img :src="cnic_bucket_path+company_user.cnic_back_path" alt="CNIC Back side not uploaded" style="width:100px;height:69px;">
                                                                            <!-- <img :src="$global.aws_base_url+'/images/img-placeholder.png'" alt=""> -->
                                                                        </div>
                                                                        <div v-else class="text-danger">
                                                                            CNIC Back side not uploaded
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-holder text-right p-3">
                                    <div v-if="company_details.company_status == 'PENDING' || company_details.company_status == 'CHECKED'">
                                        <div v-if="approve_onboarded_company">
                                            <router-link :to="{path: '/allCompanies'}" class="mr-2 btn">Cancel</router-link>
                                            <button type="button" class="btn mr-2 btn-lg btn-danger" @click="verifycompany('reject')">Reject <small>(Company)</small></button>
                                            <button type="button" class="btn mr-2 btn-lg btn-success" @click="verifycompany('approve')">Approve <small>(Company)</small></button>
                                        </div>
                                        <div v-else>
                                            <template v-if="company_details.company_status == 'PENDING'">
                                                <router-link :to="{path: '/allCompanies'}" class="mr-2 btn">Cancel</router-link>
                                                <button type="button" class="btn mr-2 btn-lg btn-primary" @click="verifycompany('check')">Send to Approver</button>
                                            </template>
                                            <template v-else>
                                                <router-link :to="{path: '/allCompanies'}" class="mr-2 btn">Back</router-link>
                                                <b class="text-success">Sent to Approver</b>
                                            </template>
                                        </div>
                                    </div>
                                    <div v-else-if="company_details.company_status == 'APPROVED'" class="text-success">
                                        <b>APPROVED COMPANY</b>
                                    </div>
                                    <div v-else-if="company_details.company_status == 'REJECTED'" class="text-danger">
                                        <b>REJECTED COMPANY</b> &nbsp;&nbsp;&nbsp;
                                        <button type="button" class="btn mr-2 btn-lg btn-success" @click="verifycompany('approve_rejected')">Approve <small>(Company)</small></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="crud_company === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_company === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                crud_company: null,
                companyId:'',
                required_documents: [],
                company_details: [],
                uploaded_documents: [],
                company_users: [],
                risk_rating: [],
                cnic_bucket_path:'',
                documents_bucket_path:'',
                popup_image_path:'',
                verifyDocumentId:null,
                documentVerification:null,
                documentVerificationReasonText:'',
                documentVerificationReason:'',
                documentVerificationErrorMessage:'',
                companyVerification:null,
                companyVerificationReason:'',
                companyVerificationErrorMessage:'',
                approve_onboarded_company : null,
                approve_onboarded_company_document : null,
                approverAction : 1
            }
        },
        methods: {
            getOnboardUserDetails(){
                axios.post('/apiV2/digitalOnboarding/getOnboardingUserDetails',{companyId:this.companyId})
                .then(res => {
                    if(res.status == 200){
                        if ( res.data.code == 200 ) {
                            this.company_details = res.data.data.company[0];
                            this.company_users = res.data.data.company;
                            this.uploaded_documents = res.data.data.company_documents;
                            this.required_documents = res.data.data.required_documents;
                            this.cnic_bucket_path = res.data.data.cnic_bucket_path;
                            this.documents_bucket_path = res.data.data.documents_bucket_path;
                            this.risk_rating = res.data.data.riskRating;
                            setTimeout(function () {
                                $(".uploaded-file").html('');
                                $(".btn-upload-file").html("Upload").removeClass('showimage');
                            },500);
                            } else {
                            this.showAlertBox('error','Error to load form data');
                        }
                        
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            view_image(image_path){
                this.popup_image_path = image_path;
                $('#popupModal').modal('show');  
            },
            downloadImg(responseUrl){
                var link = document.createElement('a');
                link.href = responseUrl;
                link.target = "_blank";
                link.download = 'Download.jpg';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            documentVerify(id,action) {
                this.verifyDocumentId = id;
                $('#getDocumnentVerificationReason').modal('show');  
                this.documentVerificationReason = '';
                if(action=='approve') {
                    this.documentVerificationReasonText = 'Approve';
                } else {
                    this.documentVerificationReasonText = 'Reject';
                }
            },
            updateVerificationStatus(){
                this.disableButton('verify_document','Sending…',true);
                
                this.$Progress.start();
                this.documentVerificationErrorMessage='';
                if(typeof(this.documentVerificationReason) == 'undefined' || this.documentVerificationReason == null || this.documentVerificationReason == ''){
                    this.documentVerificationErrorMessage=' Please provide reason!';
                    return false;
                }
                if(this.documentVerificationReasonText=='Approve'){
                    this.documentVerification=1;
                } else {
                    this.documentVerification=0;
                }
                var data = {
                    'document_id' : this.verifyDocumentId,
                    'verification' : this.documentVerification,
                    'verification_reason' : this.documentVerificationReason
                };
                axios.post('/apiV2/digitalOnboarding/verifyCompanyDocument',data)
                .then((response) => {
                    if(response.status == 200){
                        if(response.data.code == 200){
                            this.showToastBox('success',response.data.msg);
                            $('#getDocumnentVerificationReason').modal('hide'); 
                            this.getOnboardUserDetails();
                            this.disableButton('verify_document','Submit',false);
                        } else {
                            this.showToastBox('error',response.data.msg);
                            this.disableButton('verify_document','Submit',false);
                        }
                    }else{
                        this.showAlertBox('error','There is some problem');
                        this.disableButton('verify_document','Submit',false);
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
                this.$Progress.finish();

            },
            disableButton(id,value,state) {
                $('#'+id).attr('disabled',state); 
                $('#'+id).html(value);
            },
            verifycompany(action) {
                this.companyVerification='';
                this.companyVerificationReason='';
                this.$Progress.start();
                if(action=='approve') {
                        swal.fire({
                            text: "Do you want to Approve this company?",
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Yes, Approve it!',
                            cancelButtonText: 'No, cancel!',
                            reverseButtons: true
                        }).then((result) => {
                            if (result.value) {
                                this.companyVerification=1;
                                this.updateCompanyStatus();
                            } else if (result.dismiss === Swal.DismissReason.cancel){
                                swal.fire(
                                    'Cancelled',
                                    'Your decision has been cancelled',
                                    'error'
                                )
                            }
                        })
                } else if (action=='reject') {
                    this.companyVerification=0;
                    $('#getCompanyVerificationReason').modal('show');  
                } else if (action=='check') {
                    this.companyVerification=2;
                    $('#getCompanyVerificationReason').modal('show');  
                } else if (action == 'approve_rejected') {
                    this.companyVerification = 3;
                    $('#getCompanyVerificationReason').modal('show');
                }
                this.$Progress.finish();
            },
            updateCompanyStatus() {
                this.disableButton('reject_company','Sending…',true);
                if(this.companyVerification==0 || this.companyVerification==2 || this.companyVerification==3) {
                    this.companyVerificationErrorMessage='';
                    if(typeof(this.companyVerificationReason) == 'undefined' || this.companyVerificationReason == null || this.companyVerificationReason == ''){
                        this.companyVerificationErrorMessage=' Please provide reason!';
                        this.disableButton('reject_company','Submit',false);
                        return false;
                    }
                }
                var data = {
                    'company_id' : this.companyId,
                    'verification' : this.companyVerification,
                    'verification_reason' : this.companyVerificationReason,
                    'approver_action' : this.approverAction
                };
                axios.post('/apiV2/digitalOnboarding/verifyCompany',data)
                .then((response) => {
                    if(response.status == 200){
                        if(response.data.code == 200){
                            this.showToastBox('success',response.data.msg);
                            $('#getCompanyVerificationReason').modal('hide'); 
                            this.getOnboardUserDetails();
                            this.disableButton('reject_company','Submit',false);
                        } else {
                            this.showToastBox('error',response.data.msg);
                            this.disableButton('reject_company','Submit',false);
                        }
                    }else{
                        this.showAlertBox('error','There is some problem');
                        this.disableButton('reject_company','Submit',false);
                    }
                }).catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','There is some problem');
                });
            },
            saveRiskRating(){
                axios.post('/apiV2/digitalOnboarding/saveCompanyRiskRating',{companyId:this.companyId})
                    .then(res => {
                        if(res.status == 200){
                            if ( res.data.code == 200 ) {
                                this.showToastBox('success','Company Risk Rating saved Successfully!');
                            } else if(res.data.code == 202){
                                this.showToastBox('info','Same record exists for this month!');
                            } else {
                                this.showAlertBox('error','something went wrong');
                            }

                            this.$Progress.finish();
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','something went wrong');
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','something went wrong');
                    });
            }
        },
        mounted() {
            this.crud_company = true;
            this.$Progress.start();
            this.companyId = this.$route.params.id;
            this.getOnboardUserDetails();
            this.$Progress.finish();
            this.$Progress.start();
            this.can('approve_onboarded_company|approve_onboarded_company_document').then(result => {
                this.approve_onboarded_company = result.approve_onboarded_company;
                this.approve_onboarded_company_document = result.approve_onboarded_company_document;
            }).then(result => {
                if(this.crud_company == true){
                    this.companyId = this.$route.params.id;
					this.getOnboardUserDetails();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
    }
</script>
